export default {
  page: {
    myShop: '主商城',
    screenText: '筛选',
    clearBtnText: '清空',
    submitText: '搜索',
    exportText: '加入下载',
    exportLabel: '下载模板',
    conditionsLabel: '条件：',
    categoryLabel: '品类',
    brandLabel: '品牌',
    noData: '暂无数据',
    selectShopMsg: '请选择商城',
    selectFormatMsg: '选择下载模板',
    selectCategoryMsg: '选择品类',
    selectBrandMsg: '选择品牌',
    benchmarkShopSearch: '选择比较商城',
    brand_tab: '品牌',
    shop_tab: '商城',
    brand_tab1: '已选择',
  },
  filter: {
    price: '价格类型',
    Prmotion: '活动类型',
    monitored: '对比商城',
    selected: '已选',
    byMonth: '按月',
    byDay: '按日',
    selectPrice: '请选择价格类型',
  },
  showMsg: {
    title_0: 'Retail price',
    txt_0: 'The original price displayed on the website of the retailers.',
    title_1: 'Price after best discount',
    txt_1: 'The best price after highest discount displayed on the website and external discounts.',
    title_2: 'On sale price',
    txt_2: 'The discount price offered by the retailers.',
    title_3: 'Retailer Dis-Price',
    txt_3:
      'The price on top of discount based on ret-price or the estimated actual price on top of discount.',
    title_4: 'Cashback Price',
    txt_4: 'only applicable for Korean retailers.',
    title_5: 'Tax-free Price',
    txt_5: `Tick to show the prices after tax refund (only applicable to duty-paid retailers.) For North American retailers, select this price type to show the prices displayed on their website.
            For Japanese retailers, select  this price type to show the prices displayed on the website minus tax refund. `,
    title_6: 'Retailer Promotion',
    txt_6:
      'Display the information of the best discount promotion on the website and external promotions. If different tiers promotions reflect the same discount level, the promotion info is displayed randomly.',
    title_7: 'Best Retailer Discount',
    txt_7: 'To display the promotion info of the best discount on the website.',
    title_8: 'Cashback',
    txt_8: 'Cashback rate, only applicable to Korean retailers.',
    title_9: 'Currency Conversion',
    txt_9: 'To check the box, the prices will show in the same selected currency.',
    title_10: 'Status',
    txt_10: "To show SKU's historical status in the excel sheet.",
    title_11: 'Clearance Price',
    txt_11: 'Click to display the clearance prices in the excel sheet.',
    title_12: 'Ref Price',
    txt_12:
      'Because the retailer website does not display the original price of the product, hence we use the price from other retailers as references.',
  },
};
